<template>
    <ul class="nav">
        <router-link v-if="(position==='left')" :to="{ name: 'dashboard'}" tag="li" class="nav-item">
            <a href>
                <open-icon glyph="tachometer-alt" class="mr-2" />
                {{ $root.translate("Dashboard") }}
            </a>
        </router-link>
        <router-link v-if="(position==='left')" :to="{ name: 'property.list'}" tag="li" class="nav-item">
            <a href>
                <open-icon glyph="folder" class="mr-2" />
                {{ $root.translate("Property:::Properties", {}, 2) }}
            </a>
        </router-link>
        <router-link v-if="(position==='left')" :to="{ name: 'custom-assets'}" tag="li" class="nav-item">
            <a href>
                <open-icon glyph="star" class="mr-2" />
                {{ $root.translate("Asset:::Assets", {}, 2) }}
            </a>
        </router-link>

        <li v-if="is_at_least_assistant && position==='left'" class="divider">
        <li v-if="is_at_least_assistant && position==='left'" class="label">{{ $root.translate("Administration") }}</li>

        <router-link v-if="is_at_least_assistant && position==='left'" tag="li" :to="{ name: 'user.list'}" class="nav-item">
            <a href>
                <open-icon glyph="users" class="mr-2" />
                {{ $root.translate("User:::Users", {}, 2) }}
            </a>
        </router-link>
        <router-link v-if="is_at_least_assistant && position==='left'" tag="li" :to="{ name: 'assets'}" class="nav-item">
            <a href>
                <open-icon glyph="star" class="mr-2" />
                {{ $root.translate("Asset:::Assets", {}, 2) }}
            </a>
        </router-link>
        <router-link v-if="is_at_least_administrator && position==='left'" tag="li" :to="{ name: 'rate-cards'}" class="nav-item">
            <a href>
                <open-icon glyph="th-list" class="mr-2" />
                {{ $root.translate("Rate Cards") }}
            </a>
        </router-link>
        <router-link v-if="is_at_least_assistant && position==='left'" tag="li" :to="{ name: 'settings'}" class="nav-item">
            <a href>
                <open-icon glyph="cog" class="mr-2" />
                {{ $root.translate("App Settings") }}
            </a>
        </router-link>
    </ul>
</template>

<script type="text/javascript">
import utilities from "../mixins/Is"

import { OpenIcon } from "../nibnut/components"

export default {
    mixins: [utilities],
    components: {
        OpenIcon
    },
    computed: {
        current_year () {
            return this.$moment().format("YYYY")
        }
    },
    props: [
        "position"
    ],
    data () {
        return {
        }
    }
}
</script>
